import api from './api';
import { Tarefa } from '../types';

// Interface para os filtros de listagem de tarefas do departamento
export interface TarefaDepartamentoFiltros {
  status?: string;
  prioridade?: string;
  responsavel?: string;
  departamento?: string; // Para administradores especificarem o departamento
  pagina?: number;
  limite?: number;
  dataInicio?: string;
  dataFim?: string;
}

// Interface para a resposta paginada
export interface RespostaPaginada<T> {
  success: boolean;
  tarefas: T[];
  paginacao: {
    pagina: number;
    limite: number;
    total: number;
    totalPaginas: number;
  };
}

export const tarefaDepartamentoService = {
  /**
   * Busca todas as tarefas ativas do departamento com filtros opcionais e suporte a paginação
   */
  listarTarefasAtivasDepartamento: async (filtros?: TarefaDepartamentoFiltros) => {
    try {
      const params = new URLSearchParams();
      
      if (filtros) {
        // Adicionar todos os filtros disponíveis
        if (filtros.status) params.append('status', filtros.status);
        if (filtros.prioridade) params.append('prioridade', filtros.prioridade);
        if (filtros.responsavel) params.append('responsavel', filtros.responsavel);
        if (filtros.departamento) params.append('departamento', filtros.departamento);
        if (filtros.pagina) params.append('pagina', String(filtros.pagina));
        if (filtros.limite) params.append('limite', String(filtros.limite));
        if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
        if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
      }
      
      const response = await api.get(`/tarefas-departamento?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar tarefas ativas do departamento:', error);
      throw error;
    }
  },
  
  /**
   * Exporta tarefas ativas do departamento para CSV
   */
  exportarTarefasAtivasDepartamento: async (filtros?: TarefaDepartamentoFiltros) => {
    try {
      const params = new URLSearchParams();
      
      if (filtros) {
        if (filtros.status) params.append('status', filtros.status);
        if (filtros.prioridade) params.append('prioridade', filtros.prioridade);
        if (filtros.responsavel) params.append('responsavel', filtros.responsavel);
        if (filtros.departamento) params.append('departamento', filtros.departamento);
        if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
        if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
      }
      
      // Adicionar parâmetro de exportação
      params.append('formato', 'csv');
      
      const response = await api.get(`/tarefas-departamento/exportar?${params.toString()}`, {
        responseType: 'blob'
      });
      
      // Criar URL para download do arquivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tarefas-departamento-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      return { success: true };
    } catch (error) {
      console.error('Erro ao exportar tarefas ativas do departamento:', error);
      throw error;
    }
  }
};

export default tarefaDepartamentoService;
